// **React Imports
import React from 'react'

// **MUI Imports
import { Button, Card, CardContent, Typography } from '@mui/material'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, isUserOffline: !navigator.onLine }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch() {
    if (!navigator.onLine) {
      this.setState({ isUserOffline: true })
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card>
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography variant="h2" sx={{ mb: 1.5 }}>
              {this.state.isUserOffline
                ? 'You are offline 🚫'
                : 'Something went wrong ⚠️'}
            </Typography>
            <Typography sx={{ mb: 6, color: 'text.secondary' }}>
              {this.state.isUserOffline
                ? 'Please check your internet connection and try again.'
                : 'An unexpected error has occurred. Please refresh the page or try again later.'}
            </Typography>
            <Button
              variant="contained"
              onClick={() => {
                window.location.reload()
              }}
            >
              Reload
            </Button>
          </CardContent>
        </Card>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
